import { useCart } from "../../../stores/hooks/useCart";
import { useIsLoggedOn } from "../../../stores/hooks/useIsLoggedOn";

export const useShouldRenderOrderNowButton = (): boolean => {
  const isLoggedOn = useIsLoggedOn();
  const cart = useCart();

  const shouldRenderOrderNowButton = isLoggedOn
    ? cart?.supportDealerOrder
    : cart?.supportConsumerOrder;

  return Boolean(shouldRenderOrderNowButton);
};
